module.exports = __webpack_public_path__ + "static/media/office_3@2x.366954e5.jpg";